'use client';

import type { HomePageSelectionListGetPayload } from '@coas/db/model';
import { cn } from '@coas/ui/lib';
import Image from 'next/image';
import Link from 'next/link';
import { imgLoader } from '~/shared/lib';

type SelectionList = HomePageSelectionListGetPayload<{
    include: { selection: { include: { image: true } } };
}>;

interface Props {
    selectionLists: SelectionList[];
}

export const SelectionList = ({ selectionLists }: Props) => {
    return (
        <>
            {selectionLists.map(list => {
                const { width, height } =
                    list.selection.image?.height && list.selection.image.width
                        ? { width: list.selection.image.width, height: list.selection.image.height }
                        : { width: 0, height: 0 };

                return (
                    <Link
                        key={list.id}
                        href={`/lists/${list.selection.slug}`}
                        className={'relative aspect-product w-full bg-white'}
                    >
                        {list.selection.image !== null && (
                            <Image
                                loader={imgLoader({
                                    src: list.selection.image.key,
                                    width: list.selection.image.width,
                                    quality: 75,
                                })}
                                src={list.selection.image.key}
                                placeholder='blur'
                                blurDataURL={list.selection.image.lqip ?? undefined}
                                className={width > height ? 'object-contain' : 'object-cover'}
                                alt={list.selection.image.alt}
                                fill
                            />
                        )}
                        <div
                            className={cn(
                                'absolute inset-x-0 bottom-0 p-page-1/2 pt-page',
                                'flex flex-col items-center justify-center',
                                'bg-gradient-to-t from-neutral-950/50 from-20% to-transparent',
                            )}
                        >
                            <span
                                className={cn(
                                    'text-center font-futura font-700',
                                    'text-18 sm:text-24 md:text-24 lg:text-18 xl:text-24',
                                    'text-neutral-50',
                                )}
                            >
                                {list.selection.title}
                            </span>
                        </div>
                    </Link>
                );
            })}
        </>
    );
};
